import React from 'react';
import { Route, Routes } from 'react-router-dom';
import AgentSummary from './AgentSummary';
import AgentDatewiseSummary from './AgentDatewiseSummary';
import AgentUsers from './AgentUsers';

const CallerAgentDashboard = () => {
  return (
    < div >
      <Routes>
        <Route exact path={'/'} element={<AgentSummary />} />
        <Route exact path={`date-wise-summary/:agentName/:agentNumber/:dispositionStatus`} element={<AgentDatewiseSummary />} />
        <Route exact path={`agent-users/:agentName/:agentNumber/:callingDate/:dispositionStatus`} element={<AgentUsers />}/>
      </Routes>
    </div >
  );
}

export default CallerAgentDashboard;
